module.exports = __webpack_public_path__ + "static/media/product24.9ef6290b.jpg";